import React, { useEffect } from "react";
import HeaderSection from "../components/shared/HeaderSection";
import VisionMissionSection from "../components/pages/about/InfoCard";
import TeamSection from "../components/pages/about/TeamSection";
import FeaturesSection from "../components/pages/homepage/FeaturesSection";
import ContactForm from "../components/pages/homepage/ContactForm";
import ZakatConsultancyAbout from "../components/pages/about/ZakatConsultancyAbout";
import { fetchAboutData } from "../redux/slices/AboutSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/shared/Loader";
import { useTranslation } from "react-i18next";
import MetaTags from "../components/shared/MetaTags";

const About = () => {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language;
  const dispatch = useDispatch();
  const { data, status, error } = useSelector((state) => state.about);
  useEffect(() => {
    dispatch(fetchAboutData());
  }, [dispatch]);

  if (status === "loading") {
    return <Loader />;
  }

  if (status === "failed") {
    return <div>Error: {error}</div>;
  }

  return (
    <>
    <MetaTags/>
      <HeaderSection title={t("banner.aboutberg")} />
      <ZakatConsultancyAbout data={data?.data?.about} />
      <VisionMissionSection cards={data?.data?.cards} />
      <TeamSection
        members={data?.data?.team}
        team_description={data?.data?.about?.team_description[currentLang]}
        team_sub_description={data?.data?.about?.team_sub_description[currentLang]}
      />
      <FeaturesSection data={data?.data?.features} />
      <ContactForm />
    </>
  );
};

export default About;
